
import Vue from 'vue'
import { v4 as uuid } from 'uuid'
import { mapGetters } from 'vuex'
import { defineComponent } from 'vue'


export default Vue.extend({
  name: 'YourComponentName',
  props: {
    rel: { type: String, default: '' },
    name: { type: String, default: 'Bay 01' },
    selectedContainerType: { type: String, default: 'standard' },
    minHoldTiers:{default: 0},
    data: {
      type: Object,
      default: () => ({
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }]
      })
    },
    mirrorMode: { type: Boolean, default: false }
  },
  data() {
    return {
      ctrlKey: false,
      selectedCells: [],
      CELL_WIDTH: 20,
      reeferImage: 'your-image-path',
      textConfig: {
        fontSize: 10,
        fill: '#D0D0D0'
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedHatchIndex: 'getSelectedHatchIndex',
    }),
    configKonva() {
      return {
        width: 100 + this.data.cols * this.CELL_WIDTH,
        height: 60 + this.data.rows * this.CELL_WIDTH
      }
    },
    containers() {
      const thisComponentRef = this
      const cols = this.data.cols
      const rows = this.data.rows
      let stroke = '#A0A0A0'
      let hoverStroke = '#000000'
      let strokeWidth = 0.3
      let hoverStrokeWidth = 1
      const newContainers = this.data.cells.map((c, index) => {

        let cellData = {
          ...c,
          id: uuid(),
          x: ((index % cols)) * this.CELL_WIDTH + 50,
          y: (rows - 1 - Math.floor(index / cols)) * this.CELL_WIDTH + 5,
          width: this.CELL_WIDTH,
          height: this.CELL_WIDTH,
          fill: c.existed ? '#5B646B' : 'white',
          stroke: '#A0A0A0',
          strokeWidth: 0.4,
          type: 'standard',
          onmousedown(evt) {
            if (thisComponentRef.ctrlKey)
              thisComponentRef.selectCell(index)
            else
              thisComponentRef.handleClick(index, c, true)
          },
          onmouseup(evt) {
            thisComponentRef.EndSelectedIndexCell = index
            if (thisComponentRef.ctrlKey)
              thisComponentRef.colorAndSelectCell()
          },
          onmouseover(evt) {
              const shape = evt.target
              shape.stroke(hoverStroke)
              shape.strokeWidth(hoverStrokeWidth)
              document.body.style.cursor = 'pointer'            
          },
          onmouseout(evt) {
            const shape = evt.target
            document.body.style.cursor = 'default'
            shape.stroke(stroke)
            shape.strokeWidth(strokeWidth)
          },
        }
        return cellData;
      })
      return newContainers



    }
  },
  methods: {
    reeferConfig(container) {
      return {
        x: container.x,
        y: container.y,
        listening: false,
        // width: this.CELL_WIDTH,
        width: (() => {
          return this.CELL_WIDTH
        })(),
        height: this.CELL_WIDTH,
        image: this.reeferImage,
      }
    },
    changeCellProperty(hatchIndex, cellIndex, property, currentValue, isToggle) {
      this.$store.dispatch('changeCellProperty', { hatchIndex, deckPosition: 'hold', bayType: this.rel, cellIndex, property, currentValue , isToggle})
    },
    handleClick(containerIndex: number, container: any) {

      this.updateContainer(container, containerIndex,true)

      if (this.mirrorMode === true) {
        const currentRowIndex = Math.floor(containerIndex / this.data.cols)
        const currentColumnIndex = containerIndex % this.data.cols
        const mirrorColumnIndex = (this.data.cols) - currentColumnIndex
        const mirrorIndex = currentRowIndex * this.data.cols + mirrorColumnIndex - 1

        if (mirrorIndex !== containerIndex)
          this.updateContainer(container, mirrorIndex,true)
        if (this.containers[mirrorIndex].fill !== this.containers[containerIndex].fill) {
          this.updateContainer(container, mirrorIndex,true)
        }
      }
    },
    handleRangeSelect(containerIndex: number, key: string, value: any) {
      this.changeCellProperty(this.selectedHatchIndex, containerIndex, key, value, false)

      if (this.mirrorMode === true) {
        const currentRowIndex = Math.floor(containerIndex / this.data.cols)
        const currentColumnIndex = containerIndex % this.data.cols
        const mirrorColumnIndex = (this.data.cols) - currentColumnIndex
        const mirrorIndex = currentRowIndex * this.data.cols + mirrorColumnIndex - 1

        if (mirrorIndex !== containerIndex)
          this.changeCellProperty(this.selectedHatchIndex, mirrorIndex, key, value, false)
        if (this.containers[mirrorIndex].fill !== this.containers[containerIndex].fill) {
          this.changeCellProperty(this.selectedHatchIndex, mirrorIndex, key, value, false)
        }
      }
    },

    updateContainer(container, cellIndex, isToggle) {
      // const Foundcontainer = this.containers.find(c => c.id === id)
      if (this.selectedContainerType === 'standard') {
        this.changeCellProperty(this.selectedHatchIndex, cellIndex, 'existed', container.existed, isToggle)
      } else if (this.selectedContainerType === 'reefer') {
        this.changeCellProperty(this.selectedHatchIndex, cellIndex, 'isReefer', container.isReefer, isToggle)
      } else if (this.selectedContainerType === '45foot') {
        this.changeCellProperty(this.selectedHatchIndex, cellIndex, 'is45Foot', container.is45Foot, isToggle)
      }
    },
    getXLabels() {
      let labels = []
      let middle = this.data.cols % 2 === 0 ? this.data.cols / 2 : Math.floor(this.data.cols / 2)
      let startNumber = this.data.cols % 2 === 0 ? 1 : 0
      for (let i = 0; i < this.data.cols; i++) {
        if (this.data.cols % 2 === 0) {
          labels[middle + Math.floor((i * ((-1) ** i)) / 2)] = (i + 1).toString().padStart(2, '0')
        } else {
          labels[middle + Math.ceil((i * ((-1) ** (i - 1))) / 2)] = (startNumber + i).toString().padStart(2, '0')
        }
      }
      return labels
    },
    getYLabels() {
      let labels = []
      for (let i = this.data.rows; i >= 0; i--) {
        labels.push((this.minHoldTiers + i * 2).toString().padStart(2, '0'))
      }
      return labels
    },
    getXLabelConfig(value: string, index: number) {
      return {
        text: value,
        x: 55 + index * this.CELL_WIDTH,
        y: 10 + this.data.rows * this.CELL_WIDTH,
        fontSize: 11,
        listening: false,
        fill: '#707070'
      }
    },
    getYLabelConfig(value: string, index: number) {
      return {
        text: value.toString(),
        x: this.data.cols * this.CELL_WIDTH + 55,
        y: - 10 + index * this.CELL_WIDTH,
        fontSize: 11,
        listening: false,
        fill: '#707070'
      }
    },


    // ... your methods ...
    getTextConfig(container) {
      return {
        ...this.textConfig,
        text: container.isReefer ? 'RE' : container.is45Foot ? '45' : '',
        x: container.x + 2,
        y: container.y + 2
      }
    },
    onKeyPress(event) {
      if (event.ctrlKey) {
        this.ctrlKey = true
      }
    },
    onkeyup(event) {
      this.ctrlKey = false
      this.selectedCells = []
    },
    isSelected(index) {
      const cols = this.data.cols
      if (this.selectedCells.length < 2) return false;
      const [start, end] = this.selectedCells.sort((a, b) => a - b);
      var startRow = Math.floor(start / cols);
      var endRow = Math.floor(end / cols);
      var startCol = start % cols;
      var endCol = end % cols;
      const row = Math.floor(index / cols);
      const col = index % cols;
      if (startCol > endCol) {
        const temp = startCol;
        startCol = endCol;
        endCol = temp;
      }
      return row >= startRow && row <= endRow && col >= startCol && col <= endCol;
    },
    convertKey(value) {
      switch (value) {
        case "standard":
          return "existed"
        case "reefer":
          return "isReefer"
        case "45foot":
          return "is45Foot"
        default:
          return ""
      }
    },
    colorAndSelectCell() {
      if (this.selectedCells.length < 2) return;
      var context = this;
      var indexs = [];
      var oneCellIsActive = false;
      this.data.cells.forEach(function (value, index) {
        if (context.isSelected(index)) {
          indexs.push(index)
          var key = Object.keys(value)
            .find(key => key === context.convertKey(context.selectedContainerType))
          if (value[key] == true) {
            oneCellIsActive = true;
          }
        }
      })

      indexs.forEach(index => {
        if (oneCellIsActive) {
          if (context.selectedContainerType === 'standard') {
            context.handleRangeSelect(index, 'existed', false, false)
          } else if (context.selectedContainerType === 'reefer') {
            context.handleRangeSelect(index, 'isReefer', false, false)
          } else if (context.selectedContainerType === '45foot') {
            context.handleRangeSelect(index, 'is45Foot', false, false)
          }
        }
        else {
          if (context.selectedContainerType === 'standard') {
            context.handleRangeSelect(index, 'existed', true, false)
          } else if (context.selectedContainerType === 'reefer') {
            context.handleRangeSelect(index, 'isReefer', true, false)
          } else if (context.selectedContainerType === '45foot') {
            context.handleRangeSelect(index, 'is45Foot', true, false)

          }
        }
      })
      this.selectedCells = []
    },
    selectCell(index) {
      if (this.selectedCells.length < 2) {
        this.selectedCells.push(index);
      } else {
        this.selectedCells = [index];
      }
    }

    // ... other methods ...
  },
  mounted() {
    const reeferImage = new window.Image()
    reeferImage.src = 'media/svg/vesselProfile/Reefer.svg'
    reeferImage.onload = () => {
      // set image only when it is loaded
      this.reeferImage = reeferImage
    }
  },
  created() {
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keyup', this.onkeyup);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keyup', this.onkeyup);
  },
})
